import { render, staticRenderFns } from "./AddToCartAction.vue?vue&type=template&id=14774ab0"
import script from "./AddToCartAction.vue?vue&type=script&lang=ts"
export * from "./AddToCartAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports